import { __extends } from "tslib";
import * as React from 'react';
import { namespacedClassnames } from '../../../common/namespace-classes';
import { hex2Rgb } from '@wix/answers-lib';
export var LegendLabelViewKey = 'legend-label-view';
var LegendLabelView = /** @class */ (function (_super) {
    __extends(LegendLabelView, _super);
    function LegendLabelView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isMouseOver: false
        };
        _this.onClick = function () {
            if (!_this.props.disabled) {
                _this.props.onChange(!_this.props.value);
            }
        };
        _this.createStyles = function (color, isSelected) {
            var isHover = _this.state.isMouseOver;
            var rgb = hex2Rgb(color);
            var alpha = isSelected ?
                isHover ? '.8' : '1' :
                isHover ? '.1' : '0';
            return {
                color: isSelected ? '#ffffff' : color,
                border: "1px solid " + color,
                background: "rgba(" + rgb.r + ", " + rgb.g + ", " + rgb.b + ", " + alpha + ")"
            };
        };
        _this.toggleHover = function (isOver) { return function () { return _this.setState({ isMouseOver: isOver }); }; };
        return _this;
    }
    LegendLabelView.prototype.render = function () {
        var props = this.props;
        var label = props.label;
        var classNames = namespacedClassnames(LegendLabelViewKey, props.className, { disabled: props.disabled, selected: props.value });
        var style = this.createStyles(label.color, props.value);
        return (React.createElement("div", { className: classNames, onClick: this.onClick, onMouseEnter: this.toggleHover(true), onMouseLeave: this.toggleHover(false), style: style },
            React.createElement("div", { className: 'label-name' }, label.name),
            React.createElement("div", { className: 'label-value' }, label.value)));
    };
    return LegendLabelView;
}(React.PureComponent));
export { LegendLabelView };
//# sourceMappingURL=index.js.map